import { gql } from '@apollo/client';

export const REMOVE_ATTENDEE_FROM_ACTIVITY = gql`
  mutation removeAttendeeFromActivity($input: RemoveAttendeeFromActivityInput!) {
    activity: removeAttendeeFromActivity(input: $input) {
      id
    }
  }
`;
